export enum GenieAction {
  Ask = 'ask',
  ShowSubcategories = 'show_subcategories',
  NoMatch = 'no_match',
}

export interface GenieSubcategory {
  id: string;
  name: string;
  icon: string;
  tagline: string;
  categoryId: string;
  categoryTitle: string;
}

export interface GenieChatResponse {
  reply: string;
  action: GenieAction;
  suggestions: string[];
  subcategories: GenieSubcategory[];
}

export interface GenieChatTurn {
  role: "user" | "genie";
  text: string;
}
